import { Group, Skeleton, Stack, VisuallyHidden } from '@mantine/core';

type Props = {
  /** Nombre de champs (libellé + saisie) simulés. */
  fields?: number;
  /** Libellé lu par les lecteurs d'écran pendant le chargement. */
  label: string;
};

/** Squelette générique affiché pendant le chargement des données d'un formulaire. */
const FormSkeleton = ({ fields = 6, label }: Props) => (
  <Stack gap="md" role="status" aria-busy="true">
    <VisuallyHidden>{label}</VisuallyHidden>
    {Array.from({ length: fields }, (_, index) => (
      <Stack key={index} gap={6} aria-hidden="true">
        <Skeleton height={14} width="30%" />
        <Skeleton height={36} />
      </Stack>
    ))}
    <Group justify="flex-end" mt="sm" aria-hidden="true">
      <Skeleton height={36} width={100} />
      <Skeleton height={36} width={120} />
    </Group>
  </Stack>
);

export default FormSkeleton;
